import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getSzakMintaTerve, createSzakMintaTerve, updateSzakMintaTerve, getSzak, getSzakfelelosBySzakkod } from "../../apis/SzakokFinder";
// import "../../components/Ujszak.css";
import "./RadioButton.css";
import "./SzakjelentesCreate.css";
import SideTile from "../SideTile";
import RichTextEditor from "../RichTextEditor";
import { useFormSave } from "../../context/FormSaveContext";
import TopAlert from '../../components/TopAlert';
import { LanguageProvider, useLanguage } from "../../context/LanguageContext";
import { SZAKMINTATERVE_TRANSLATIONS } from './SzakMintaTerveTranslations';
import * as SzakMintaTerveOptions from './SzakMintaTerveOptions'; 


const SzakMintaTerveContent = ({ szakKod }) => {
    const { language, loading } = useLanguage();
    const [isSideTileVisible] = useState(true); // Added state for controlling SideTile visibility
    const { registerSaveHandler, unregisterSaveHandler } = useFormSave();
    const sideTileRef = React.useRef(null);


    const { szakId } = useParams();
    const navigate = useNavigate();

    const [szakMintaTerve, setSzakMintaTerve] = useState({
        filling_status: 1
    });

    // New state for radio button selection
    const [valtozasok, setValtozasok] = useState([]);
    const [valtozasokEgyebText, setValtozasokEgyebText] = useState("");
    const [valtozasokMegjegyzes, setValtozasokMegjegyzes] = useState("");
    
    // State for non-STEM education (AACSB)
    const [nemStemKepzesek, setNemStemKepzesek] = useState([]);
    const [nemStemKepzesekEgyebText, setNemStemKepzesekEgyebText] = useState("");
    
    // State for STEM education (ABET)
    const [stemKepzesek, setStemKepzesek] = useState([]);
    const [stemKepzesekEgyebText, setStemKepzesekEgyebText] = useState("");
    
    const [finalized, setFinalized] = useState(false); // To track if the section is finalized
    const [isNew, setIsNew] = useState(true);
    const [szakStatus, setSzakStatus] = useState(1); // Mely státuszban van a szakjelentés

    // Top alert state
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [kepzesUrlContent, setKepzesUrlContent] = useState(null); // Store kepzes_url
    const [mintatantervLinkContent, setMintatantervLinkContent] = useState(null); // Store mintatanterv_link

    // Get translations for current language - only after loading is complete
    const t = loading ? {} : (SZAKMINTATERVE_TRANSLATIONS[language] || SZAKMINTATERVE_TRANSLATIONS.hu);
    const valtozasokOptions = loading ? [] : (SzakMintaTerveOptions.VALTOZASOK_OPTIONS[language] || SzakMintaTerveOptions.VALTOZASOK_OPTIONS.hu);
    const nemStemKepzesekOptions = loading ? [] : (SzakMintaTerveOptions.NEM_STEM_KEPZESEK_OPTIONS[language] || SzakMintaTerveOptions.NEM_STEM_KEPZESEK_OPTIONS.hu);
    const stemKepzesekOptions = loading ? [] : (SzakMintaTerveOptions.STEM_KEPZESEK_OPTIONS[language] || SzakMintaTerveOptions.STEM_KEPZESEK_OPTIONS.hu);

    // Helper function to build JSONB structure for multi-select
    const buildMultiSelectData = (selectedValues, options) => {
        if (!selectedValues || selectedValues.length === 0) return null;
        return {
            selected: selectedValues,
            options: options
        };
    };

    // Segédfüggvény URL-ek kattinthatóvá tételéhez
    const formatLinkContent = (content) => {
        if (!content) return '<p style="color: #999;">Nincs elérhető adat</p>';
        
        // Letisztítjuk a HTML tageket (ha véletlenül azzal érkezne) és ellenőrizzük az URL formátumot
        const plainText = content.replace(/<[^>]*>?/gm, '').trim();
        const isUrl = plainText.startsWith('http://') || plainText.startsWith('https://');
        
        if (isUrl) {
            return `<a href="${plainText}" target="_blank" rel="noopener noreferrer" style="color: #44ACC9; text-decoration: underline; word-break: break-all;">${plainText}</a>`;
        }
        
        return content;
    };

    // Adatok lekérdezése
    useEffect(() => {
        const fetchData = async () => {
            try {
                // First, fetch szak data to get szak_kod and status
                const szakResponse = await getSzak(szakId);
                const szakKod = szakResponse.data.data.szak_kod;
                if (szakResponse.data && szakResponse.data.data) {
                    setSzakStatus(szakResponse.data.data.status);
                }
                
                // Fetch szakfelelős data to get kepzes_url and mintatanterv_link
                const szakfelelosResponse = await getSzakfelelosBySzakkod(szakKod);
                if (szakfelelosResponse.data && szakfelelosResponse.data.kepzes_url) {
                    setKepzesUrlContent(szakfelelosResponse.data.kepzes_url);
                }
                if (szakfelelosResponse.data && szakfelelosResponse.data.mintatanterv_link) {
                    setMintatantervLinkContent(szakfelelosResponse.data.mintatanterv_link);
                }

                const response = await getSzakMintaTerve(szakId);
                if (response.data && response.data.data) {
                    const data = response.data.data;
                    setSzakMintaTerve(data);
                    setFinalized(data.filling_status === 3);

                    // Load radio button selections from JSONB
                    if (data.valtozasok) setValtozasok(data.valtozasok.selected || []);
                    if (data.valtozasok_egyeb) setValtozasokEgyebText(data.valtozasok_egyeb);
                    if (data.valtozasok_megjegyzes) setValtozasokMegjegyzes(data.valtozasok_megjegyzes);
                    if (data.nem_stem_kepzesek) {
                        const selected = data.nem_stem_kepzesek.selected;
                        setNemStemKepzesek(Array.isArray(selected) ? selected : (selected ? [selected] : []));
                    }
                    if (data.nem_stem_kepzesek_egyeb) setNemStemKepzesekEgyebText(data.nem_stem_kepzesek_egyeb);
                    if (data.stem_kepzesek) {
                        const selected = data.stem_kepzesek.selected;
                        setStemKepzesek(Array.isArray(selected) ? selected : (selected ? [selected] : []));
                    }
                    if (data.stem_kepzesek_egyeb) setStemKepzesekEgyebText(data.stem_kepzesek_egyeb);

                    setIsNew(false);
                } else {
                    // Handle case when no record exists (404)
                    const newData = {
                        filling_status: 1,
                    };
                    await createSzakMintaTerve(szakId, newData);
                    setSzakMintaTerve(newData);
                    window.location.reload();
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [szakId]);

    // Register auto-save handler for token expiry
    useEffect(() => {
        const autoSaveHandler = async () => {
            const updatedData = { ...szakMintaTerve, filling_status: 2,
                valtozasok: buildMultiSelectData(valtozasok, valtozasokOptions),
                valtozasok_egyeb: valtozasokEgyebText,
                valtozasok_megjegyzes: valtozasokMegjegyzes,
                nem_stem_kepzesek: nemStemKepzesek.length > 0 ? { selected: nemStemKepzesek, options: nemStemKepzesekOptions } : null,
                nem_stem_kepzesek_egyeb: nemStemKepzesekEgyebText,
                stem_kepzesek: stemKepzesek.length > 0 ? { selected: stemKepzesek, options: stemKepzesekOptions } : null,
                stem_kepzesek_egyeb: stemKepzesekEgyebText
            };
            try {
                if (isNew) {
                    await createSzakMintaTerve(szakId, updatedData);
                } else {
                    await updateSzakMintaTerve(szakId, updatedData);
                }
            } catch (error) {
                console.error("Error auto-saving data:", error);
            }
        };

        registerSaveHandler(autoSaveHandler);

        return () => {
            unregisterSaveHandler();
        };
    }, [szakMintaTerve, isNew, szakId, registerSaveHandler, unregisterSaveHandler, valtozasok, valtozasokEgyebText, valtozasokMegjegyzes, nemStemKepzesek, nemStemKepzesekEgyebText, stemKepzesek, stemKepzesekEgyebText]);

    const handleValtozasokRadioChange = (value) => {
        setValtozasok(value);
        if (value !== 'valtozasok_egyeb') {
            setValtozasokEgyebText("");
        }
    };

    const handleValtozasokEgyebTextChange = (value) => {
        setValtozasokEgyebText(value);
    };

    const handleValtozasokMegjegyzes = (value) => {
        setValtozasokMegjegyzes(value);
    };

    const handleNemStemKepzesekCheckboxChange = (value) => {
        const exclusiveValues = ['rendszeres_meresek', 'nincs_ertekeles'];
        const isExclusive = exclusiveValues.includes(value);

        setNemStemKepzesek(prevValues => {
            if (prevValues.includes(value)) {
                // Deselecting an option
                return prevValues.filter(item => item !== value);
            } else {
                // Selecting an option
                if (isExclusive) {
                    // If selecting an exclusive option, clear all others
                    return [value];
                } else {
                    // If selecting a non-exclusive option, remove any exclusive ones
                    return [...prevValues.filter(item => !exclusiveValues.includes(item)), value];
                }
            }
        });

        if (value !== 'nemStemKepzesekEgyeb' && !nemStemKepzesek.includes(value)) {
            setNemStemKepzesekEgyebText("");
        }

        // Clear selections from stemKepzesek (Group B)
        setStemKepzesek([]);
        setStemKepzesekEgyebText("");
    };

    const handleNemStemKepzesekEgyebTextChange = (value) => {
        setNemStemKepzesekEgyebText(value);
    };

    const handleStemKepzesekCheckboxChange = (value) => {
        const exclusiveValues = ['strukturalt_meresek', 'nincs_meres'];
        const isExclusive = exclusiveValues.includes(value);

        setStemKepzesek(prevValues => {
            if (prevValues.includes(value)) {
                // Deselecting an option
                return prevValues.filter(item => item !== value);
            } else {
                // Selecting an option
                if (isExclusive) {
                    // If selecting an exclusive option, clear all others
                    return [value];
                } else {
                    // If selecting a non-exclusive option, remove any exclusive ones
                    return [...prevValues.filter(item => !exclusiveValues.includes(item)), value];
                }
            }
        });

        if (value !== 'stemKepzesekEgyeb' && !stemKepzesek.includes(value)) {
            setStemKepzesekEgyebText("");
        }

        // Clear selections from nemStemKepzesek (Group A)
        setNemStemKepzesek([]);
        setNemStemKepzesekEgyebText("");
    };

    const handleStemKepzesekEgyebTextChange = (value) => {
        setStemKepzesekEgyebText(value);
    };

    // Adatok mentése
    const handleSubmit = async (e, status) => {
        e.preventDefault();
        const updatedData = { ...szakMintaTerve, filling_status: status,
                valtozasok: buildMultiSelectData(valtozasok, valtozasokOptions),
                valtozasok_egyeb: valtozasokEgyebText,
                valtozasok_megjegyzes: valtozasokMegjegyzes,
                nem_stem_kepzesek: nemStemKepzesek.length > 0 ? { selected: nemStemKepzesek, options: nemStemKepzesekOptions } : null,
                nem_stem_kepzesek_egyeb: nemStemKepzesekEgyebText,
                stem_kepzesek: stemKepzesek.length > 0 ? { selected: stemKepzesek, options: stemKepzesekOptions } : null,
                stem_kepzesek_egyeb: stemKepzesekEgyebText
            };

        try {
            if (isNew) {
                await createSzakMintaTerve(szakId, updatedData);
            } else {
                await updateSzakMintaTerve(szakId, updatedData);
            }
            window.location.reload(); // Oldal újratöltése a mentés után
        } catch (error) {
            console.error("Error submitting data:", error);
        }
    };

    const handleNext = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/tehetseges-hallgatok`);
    };

    const handleBack = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/kepzes-celja`);
    };

    const isFormValid = () => {
        // Helper function to check if HTML content has actual text
        const hasContent = (html) => {
            if (!html) return false;
            // Remove HTML tags and check if there's actual text
            const text = html.replace(/<[^>]*>/g, '').trim();
            return text.length > 0;
        };

        // All selections must have at least one checkbox, but EITHER nemStemKepzesek OR stemKepzesek (not both required)
        const hasAllSelections = (valtozasok && valtozasok.length > 0) && (nemStemKepzesek.length > 0 || stemKepzesek.length > 0);

        // Check "egyéb" text fields only if "egyéb" is selected
        const egyebFieldsValid = 
            (!valtozasok.includes('valtozasok_egyeb') || hasContent(valtozasokEgyebText)) &&
            ((!nemStemKepzesek.includes('nemStemKepzesekEgyeb') && !stemKepzesek.includes('stemKepzesekEgyeb')) ||
            (nemStemKepzesek.includes('nemStemKepzesekEgyeb') && hasContent(nemStemKepzesekEgyebText)) ||
            (stemKepzesek.includes('stemKepzesekEgyeb') && hasContent(stemKepzesekEgyebText)));

        return (
            hasAllSelections && egyebFieldsValid
        );
    };

    const handleRevertFinalize = async (e) => {
        handleSubmit(e, 2); // Status 2-re állítása
    };

    const handleFinalize = async (e) => {
        if (isFormValid()) {
            handleSubmit(e, 3); // Véglegesítés
        } else {
            // Show top alert instead of native alert
            setAlertMessage(t.alerts.requiredFields);
            setShowAlert(true);
        }
    };

    const handleChange = (field, value) => {
        setSzakMintaTerve(prevState => ({
          ...prevState,
          [field]: value, // Save the updated HTML content
        }));
      };

    // Show loading state while language context is initializing
    if (loading) {
        return <div>Loading language...</div>;
    }

    return (
        <div className="szakjelentes-create-wrapper">
        <div className="uj-szak-page">
            {showAlert && (
                <TopAlert message={alertMessage} onClose={() => setShowAlert(false)} duration={5000} />
            )}
            <SideTile ref={sideTileRef} id={szakId} texts={t.sidebar}
            isVisible={isSideTileVisible}
            />
            <div className="uj-szak-container">
                <h1 className="esg-title">{t.esgTitle}</h1>
                <h1>{t.pageTitle}</h1>
                <form onSubmit={(e) => handleSubmit(e, 2)}>
                    <div className="card">
                        {/* 2.1-es előtöltött rész */}
                        <h2>{t.section1.title}</h2>
                        <div className="form-group">
                            <div 
                                className="read-only-content"
                                dangerouslySetInnerHTML={{ __html: formatLinkContent(kepzesUrlContent) || '<p style="color: #999;">Nincs elérhető adat</p>' }}
                                />
                            </div>
                        </div>
                    {/* 2.2-es előtöltött rész */} 
                    <div className="card">
                        <h2>{t.section2.title}</h2>
                        <div className="form-group">
                            <div 
                                className="read-only-content"
                                dangerouslySetInnerHTML={{ __html: formatLinkContent(mintatantervLinkContent) || '<p style="color: #999;">Nincs elérhető adat</p>' }}
                            />
                        </div>
                    </div>

                    <div className="card">
                        <h2>{t.section3.title}</h2>
                        <div className="form-group">
                            {valtozasokOptions.map((option) => (
                                <div className="checkbox-group" key={option.value}>
                                    <input
                                        type="checkbox"
                                        id={`valtozasok_${option.value}`}
                                        name="valtozasok"
                                        value={option.value}
                                        checked={valtozasok.includes(option.value)}
                                        onChange={(e) => {
                                            const noChangesValue = "nem_tortent"; // The value for "No changes"
                                            if (e.target.checked) {
                                                if (option.value === noChangesValue) {
                                                    // If "no changes" is selected, clear everything else and reset related fields
                                                    setValtozasok([noChangesValue]);
                                                    setValtozasokEgyebText("");
                                                } else {
                                                    // If another option is selected, remove "no changes" if it was present
                                                    setValtozasok([
                                                        ...valtozasok.filter(val => val !== noChangesValue),
                                                        option.value
                                                    ]);
                                                }
                                            } else {
                                                setValtozasok(
                                                    valtozasok.filter(val => val !== option.value)
                                                );
                                            }
                                        }}
                                        disabled={finalized}
                                    /> 
                                    <label htmlFor={`valtozasok_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                            {valtozasok.includes("valtozasok_egyeb") && (
                                <div className="egyeb-editor-container">
                                    <RichTextEditor
                                        name="valtozasokEgyebText"
                                        value={valtozasokEgyebText}
                                        onChange={handleValtozasokEgyebTextChange}
                                        disabled={finalized}
                                    />
                                </div>
                            )}
                        </div>
                        <h4>{t.section3.noteLabel}</h4>
                        <div className="form-group">
                            <RichTextEditor
                                name="valtozasok_megjegyzes"
                                value={valtozasokMegjegyzes}
                                onChange={handleValtozasokMegjegyzes}
                                disabled={finalized}
                            />
                        </div>
                    </div>

                    <div className="card">
                        <h2>{t.section4.title}</h2>
                        <h3>{t.section4.titleA}</h3>
                        <p>{t.section4.descriptionA}</p>
                        <div className="form-group">
                            {nemStemKepzesekOptions.map((option) => {
                                const exclusiveValues = ['rendszeres_meresek', 'nincs_ertekeles'];
                                const isExclusive = exclusiveValues.includes(option.value);
                                const hasExclusiveSelected = nemStemKepzesek.some(val => exclusiveValues.includes(val));
                                const shouldDisable = hasExclusiveSelected && !nemStemKepzesek.includes(option.value);

                                return (
                                    <div className="checkbox-group" key={option.value}>
                                        <input
                                            type="checkbox"
                                            id={`nem_stem_kepzesek_${option.value}`}
                                            name="nemStemKepzesek"
                                            value={option.value}
                                            checked={nemStemKepzesek.includes(option.value)}
                                            onChange={() => handleNemStemKepzesekCheckboxChange(option.value)}
                                            disabled={finalized || shouldDisable}
                                        />
                                        <label htmlFor={`nem_stem_kepzesek_${option.value}`}>{option.label}</label>
                                    </div>
                                );
                            })}
                            {nemStemKepzesek.includes("nemStemKepzesekEgyeb") && (
                                <div className="egyeb-editor-container">
                                    <RichTextEditor
                                        name="nemStemKepzesekEgyebText"
                                        value={nemStemKepzesekEgyebText}
                                        onChange={handleNemStemKepzesekEgyebTextChange}
                                        disabled={finalized}
                                    />
                                </div>
                            )}
                        </div>
            
                        <h3>{t.section4.titleB}</h3>
                        <p>{t.section4.descriptionB}</p>
                        <div className="form-group">
                            {stemKepzesekOptions.map((option) => {
                                const exclusiveValues = ['strukturalt_meresek', 'nincs_meres'];
                                const isExclusive = exclusiveValues.includes(option.value);
                                const hasExclusiveSelected = stemKepzesek.some(val => exclusiveValues.includes(val));
                                const shouldDisable = hasExclusiveSelected && !stemKepzesek.includes(option.value);

                                return (
                                    <div className="checkbox-group" key={option.value}>
                                        <input
                                            type="checkbox"
                                            id={`stem_kepzesek_${option.value}`}
                                            name="stemKepzesek"
                                            value={option.value}
                                            checked={stemKepzesek.includes(option.value)}
                                            onChange={() => handleStemKepzesekCheckboxChange(option.value)}
                                            disabled={finalized || shouldDisable}
                                        />
                                        <label htmlFor={`stem_kepzesek_${option.value}`}>{option.label}</label>
                                    </div>
                                );
                            })}
                            {stemKepzesek.includes("stemKepzesekEgyeb") && (
                                <div className="egyeb-editor-container">
                                    <RichTextEditor
                                        name="stemKepzesekEgyebText"
                                        value={stemKepzesekEgyebText}
                                        onChange={handleStemKepzesekEgyebTextChange}
                                        disabled={finalized}
                                    />
                                </div>
                            )}
                        </div>
                    </div>


                    <div className="button-container-left">
                        <button className="szak-button" type="button" onClick={handleBack}>{t.buttons.previous}</button>
                        <div className="spacer"></div>
                        <button className="szak-button" type="button" onClick={handleNext}>{t.buttons.next}</button>
                    </div>
                    <div className="szak-button-container">
                        <button className="szak-button" type="submit" disabled={finalized || szakStatus >= 2}>{t.buttons.save}</button>
                        <button className="szak-button finalize-button" type="button" onClick={finalized ? handleRevertFinalize : handleFinalize} disabled={szakStatus >= 2}>
                            {finalized ? t.buttons.unfinalize : t.buttons.finalize}
                        </button>
                    </div>
                </form>
            </div>
        </div>
        </div>
    );
};

// Wrapper component to fetch szakKod and provide LanguageContext
const SzakMintaTerve = () => {
    const { szakId } = useParams();
    const [szakKod, setSzakKod] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSzakKod = async () => {
            try {
                console.log('Fetching szakKod for szakId:', szakId);
                const response = await getSzak(szakId);
                console.log('getSzak response:', response);
                const kod = response.data?.szak_kod || response.data?.data?.szak_kod;
                console.log('Extracted szak_kod:', kod);
                setSzakKod(kod);
            } catch (error) {
                console.error("Error fetching szak_kod:", error);
                setError(error.message);
                // Set a default to prevent infinite loading
                setSzakKod('default');
            }
        };
        fetchSzakKod();
    }, [szakId]);

    if (error) {
        return <div>Error loading page: {error}</div>;
    }

    if (!szakKod) {
        return <div>Loading page...</div>;
    }

    return (
        <LanguageProvider szakKod={szakKod}>
            <SzakMintaTerveContent szakKod={szakKod} />
        </LanguageProvider>
    );
};

export default SzakMintaTerve;
